module.exports = __webpack_public_path__ + "img/Deductions-Illustration.5e8cf251.png";